import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { NewspaperModule as NewspaperComponent } from '@thd-olt-component-react/newspaper-module';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function NewspaperModule({ id }) {

  return (
    <ErrorBoundary name="newspaperModule">
      <QueryProvider key={id} cacheKey={id}>
        <NewspaperComponent
          componentId={id}
          componentClass="Newspaper"
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

NewspaperModule.propTypes = {
  id: string,
};

NewspaperModule.defaultProps = {
  id: undefined,
};